import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class WoodenBridgeFloor extends Floor {
	static key = "WoodenBridgeFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): WoodenBridgeFloor {
		const f = new WoodenBridgeFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
